import { ROUTES_PATH } from 'app/constants/Routes';

type BuildRegularizationRouteParams = {
  isCreditCardSubscription: boolean;
};

export function buildRegularizationRoute({
  isCreditCardSubscription,
}: BuildRegularizationRouteParams): string {
  const base = ROUTES_PATH.CONFIGURACOES.PLAN_AND_PAYMENT;

  const param = isCreditCardSubscription
    ? 'openCardRegularization=1'
    : 'openCompletePayment=1';

  const separator = base.includes('?') ? '&' : '?';

  return `${base}${separator}${param}`;
}
